import React from 'react';
import styled from 'styled-components';
import ActionsContextV2, { ActionsStore } from './ActionsContextV2';
import ActionsFormV2 from './actionsFormV2/ActionsFormV2';
import CenteredLoadingIndicator from '../common/CenteredLoadingIndicator';
import EmptyStateMessage from '../common/EmptyStateMessage';
import ActionsProjectSelection from './actionsFormV2/ActionsProjectSelection';
import ActionsReadOnlyEmptyState from './ActionsReadOnlyEmptyState';
import ActionsNoAccessEmptyState from './ActionsNoAccessEmptyState';
import _ from 'lodash';


const Content = styled.div`
  
`;


const renderContent = (context) => {
    const selectedProject = context.actionsRedux.selectedProject;
    const selectedFunction = selectedProject && selectedProject.selectedFunction;
    const selectedProjectFunctionDetails = context.actionsRedux.selectedProjectFunctionDetails;

    if (context.actionsRedux.fetchingProjectFunctions || context.actionsRedux.submittingActions ) {
                        
        return <CenteredLoadingIndicator/> 

    }else if (context.actionsRedux.projectFunctions && context.actionsRedux.projectFunctions.length === 0) {
        return <ActionsNoAccessEmptyState/>
                

    }else if (context.actionsRedux.projectFunctions && context.actionsRedux.projectFunctionsMine.length === 0 && !context.actionsRedux.selectedProject) {
        return <ActionsReadOnlyEmptyState context={context}/>             

    }else if (selectedProject && (!selectedFunction || !selectedProjectFunctionDetails || context.actionsRedux.fetchingProjectFunctionDetails)) {
        return <Content>
                    <ActionsProjectSelection/>
                    <CenteredLoadingIndicator/>
               </Content>

    }else  {
     return <Content>

                    <ActionsProjectSelection/>
                    <ActionsFormV2 initialValues={{selectedProjectFunctionDetails:selectedProjectFunctionDetails}}/>


                
        </Content> 
    }
}

const ActionsMainV2 = (props) => {

    return (
        <ActionsStore>
        <ActionsContextV2.Consumer>
        {context => renderContent(context)}
        </ActionsContextV2.Consumer>
                   
        
        </ActionsStore>
    )
}

export default ActionsMainV2;